import {PropsWithChildren, ReactElement} from "react";
import styled from "styled-components";

const Container = styled.div`
  padding: 90px 0 40px 0;
`;

const Layout = (props: PropsWithChildren<any>): ReactElement => {
    return (
        <Container>{props.children}</Container>
    );
};

export default Layout;